module.exports = __webpack_public_path__ + "assets/expand.03c7c0fae9c963c0f9745dc76009ce24.svg";